import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { getEditingUser } from 'auth/store/users/selectors';
import { deleteUser } from 'auth/store/users/actions';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';

const DeleteUserModal = ({
  name, closeModal, user, deleteUser,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete User</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{user && user.name}</Title3>
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteUser(user); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
DeleteUserModal.propTypes = {
  name: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: getEditingUser(state),
});

const mapDispatchToProps = {
  deleteUser,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteUserModal);
